import { Component } from 'react';

import { bugsnagError } from 'services/bugsnag';

export default class TalkableProviderHOC extends Component {
  componentDidMount () {
    const { authData, enabled, windowLoaded } = this.props;

    // keep static var of enabled so we don't run static methods when not enabled
    TalkableProviderHOC.enabled = enabled;

    // wait until window is loaded to load Talkable
    if (windowLoaded && enabled) { this.loadTalkableJS(authData); }
  }

  componentDidUpdate (prevProps) {
    const { authData, enabled, windowLoaded, location } = this.props;

    // if we didn't load in componentDidMount
    // load when window is loaded and when the path changes
    const windowJustLoaded = windowLoaded && !prevProps.windowLoaded;
    const newPath = windowLoaded && location.pathname !== prevProps.location.pathname;
    if ((windowJustLoaded || newPath) && enabled) {
      this.loadTalkableJS(authData);
    }

    // if user becomes authenticated or the user changes, re-push authentication data
    const userAuthChanged = (!prevProps.authData && authData);
    const userEmailChanged = (prevProps.authData && authData && (prevProps.authData.email !== authData.email));
    if (enabled &&
        (userAuthChanged || userEmailChanged)
    ) {
      this.userAuthenticated(this.props.authData);
    }
  }

  loadTalkableJS = (authData) => {
    try {
      let script = document.createElement('script');
      script.onload = () => {
        if (!window._talkableq) {
          bugsnagError(new Error(`Talkable loaded but window.Talkable is ${window._talkableq}`));
          return;
        }

        window._talkableq = window._talkableq || [];
        window._talkableq.unshift(['init', { site_id: 'modsy' }]);
        this.userAuthenticated(authData);
        window._talkableq.push(['register_affiliate', {}]);

        // Leaving this in for now
        console.log('Talkable Loaded');
      };
      script.async = true;
      script.src = 'https://d2jjzw81hqbuqv.cloudfront.net/integration/clients/modsy.min.js';

      // This kicks off an async download of the script
      document.head.appendChild(script);
    } catch (exception) {
      bugsnagError(new Error(`Exception encountered when trying to load Talkabele: ${exception}`));
    }
  }

  userAuthenticated = (authData) => {
    if (!TalkableProviderHOC.enabled) { return; }

    // if Talkable is not loaded yet it's okay, it will authenticate when Talkable does load
    if (!window._talkableq) {
      return;
    }

    if (authData) {
      window._talkableq.push(['authenticate_customer', {
        email: authData.email,
        first_name: authData.firstName,
        last_name: authData.lastName
      }]);
    } else {
      // spec requires us to push empty string if the user hasn't been authenticated
      window._talkableq.push(['authenticate_customer', {
        email: '', // Optional, pass when available. Example: 'customer@example.com'
        first_name: '', // Optional, pass when available. Example: 'John'
        last_name: '' // Optional, pass when available. Example: 'Smith'
      }]);
    }
  }

  static postPurchase = ({orderNumber, subtotal, couponCode, zip, address, email}) => {
    if (!TalkableProviderHOC.enabled) { return; }

    if (!window._talkableq) {
      bugsnagError(new Error(`Talkable was not loaded during post-purchase`));
      return;
    }

    var talkableData = {
      purchase: {
        order_number: orderNumber, // Unique order number. Example: '100011'
        subtotal: subtotal, // Order subtotal (pre-tax, post-discount). Example: '23.97'
        coupon_code: couponCode, // Coupon code that was used at checkout (pass multiple as an array). Example: 'SAVE20'
        shipping_zip: zip, // Optional - used for fraud protection by address. Example: '02222'
        shipping_address: address || '' // Full address of the order, make sure to strictly follow a format: 'Apt #, Street address, City, State, ZIP, Country'
      },
      customer: {
        email // Customer email address who issued a purchase. Example: 'customer@example.com'
      }
    };

    window._talkableq.push(['register_purchase', talkableData]);
  }

  render () {
    return this.props.children;
  }
}
